import { format } from "date-fns";
import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getOrderInfoLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const TmobilejOrderInfoHistory = () => {
  const [orderInfo, setOrderInfo] = useState(null);
  const { order_info_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getOrderInfoLog(order_info_id),
  });

  useEffect(() => {
    call();
    // We intentionally don't include `call` in deps to avoid refetch loops.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_info_id]);

  useEffect(() => {
    if (response && response.status) {
      setOrderInfo(response.data);
    }
  }, [response]);

  const phoneNumbersOrdered = useMemo(() => {
    if (!orderInfo?.data?.phone_numbers_ordered) return [];
    try {
      const parsed =
        typeof orderInfo.data.phone_numbers_ordered === "string"
          ? JSON.parse(orderInfo.data.phone_numbers_ordered || "[]")
          : orderInfo.data.phone_numbers_ordered;
      if (Array.isArray(parsed)) return parsed;
      return [];
    } catch (e) {
      return [orderInfo.data.phone_numbers_ordered];
    }
  }, [orderInfo]);

  if (loading) {
    return <Title content="Please wait..." variant="subtitle2" gutterBottom />;
  }

  return (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Order Info
        </Typography>
      </Box>

      {orderInfo && orderInfo.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Order ID</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Order Status</TableCell>
                    <TableCell align="left">Order Message</TableCell>
                    <TableCell align="left">Order Type</TableCell>
                    <TableCell align="left">Order Date</TableCell>
                    <TableCell align="left">Phone Numbers Ordered</TableCell>
                    <TableCell align="left">Created At</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">{orderInfo.data.order_id}</TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/tmobilej/order_info/batch/${orderInfo.data.batch_id}`}
                      >
                        {orderInfo.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={orderInfo.data.status}
                        size="small"
                        color={getChipColor(orderInfo.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {orderInfo.data.order_status}
                    </TableCell>
                    <TableCell align="left">
                      {orderInfo.data.order_status_message || "-"}
                    </TableCell>
                    <TableCell align="left">
                      {orderInfo.data.order_type || "-"}
                    </TableCell>
                    <TableCell align="left">
                      {orderInfo.data.order_date &&
                        `${format(
                          new Date(orderInfo.data.order_date),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                    <TableCell align="left">
                      {orderInfo?.data?.phone_numbers_ordered || "-"}
                    </TableCell>
                    <TableCell align="left">
                      {orderInfo.data.created_at &&
                        `${format(
                          new Date(orderInfo.data.created_at),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                    <TableCell align="left">
                      {orderInfo.data.last_updated &&
                        `${format(
                          new Date(orderInfo.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={orderInfo.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default TmobilejOrderInfoHistory;

